<template>
  <div :class="['basis-list-item', classType]" @click="toHandler">
    <div class="image-box">
      <van-skeleton
        avatar
        avatar-size="100%"
        avatar-shape="square"
        :loading="!item.cover && !item.covers"
      >
        <van-image
          lazy-load
          width="100%"
          height="100%"
          fit="fill"
          :src="item.cover || (item.covers && item.covers[0])"
        />
        <span v-if="item.locked" :class="['vip-level', 'active']">
          VIP
        </span>
      </van-skeleton>
    </div>
    <div class="info">
      <van-skeleton
        :row="3"
        :loading="!item.id"
      >
        <p class="title">
          <slot name="title" :column="item">
            {{ item.title }}
          </slot>
        </p>
        <p class="label">
          <slot name="label" :column="item">
            {{ item.publishAt }}
          </slot>
        </p>
        <div class="worth">
          <slot name="worth" :column="item" />
        </div>
      </van-skeleton>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BasisListItem',
  props: {
    item: {
      type: Object,
      required: true,
      default: () => {}
    },
    to: {
      type: [Object, String],
      required: true,
      default: () => {}
    },
    classType: {
      type: String,
      default: 'video' // video / commoditie / course / lesson
    }
  },
  methods: {
    toHandler () {
      if (this.to instanceof Object) {
        this.$router.push(this.to)
      } else {
        window.location.href = this.to
      }
    }
  }
}
</script>

<style scoped lang="scss">
.basis-list-item {
  display: block;
  border-radius:4px;
  overflow: hidden;
  box-shadow:0px 2px 4px 0px rgba(2,20,33,0.08);
  &.video {
    background-color: #fff;
    .image-box {
      @include wh(100%, 108px);
    }
    .info {
      padding: 8px 12px;
      .title {
        @include ellipsis(2, 20px);
        margin-bottom: 6px;
      }
    }
  }
  &.commoditie {
    background-color: #fff;
    .image-box {
      @include wh(100%, 108px);
    }
    .info {
      padding: 8px 12px;
      .title {
        @include ellipsis(1, 20px);
        margin-bottom: 6px;
      }
      .label {
        @include ellipsis(1, 13px);
      }
    }
  }
  &.course {
    @include flex(row);
    background-color: #fff;
    .image-box {
      @include wh(120px, 80px);
      min-width: 120px;
      border-radius:4px 0 0 4px;
      overflow: hidden;
    }
    .info {
      flex-grow: 1;
      padding: 10px 8px;
      .title {
        @include ellipsis(2, 20px);
        margin-bottom: 12px;
      }
    }
  }
  &.lesson {
    @include flex(row);
    background-color: #F4F4F4;
    .image-box {
      @include wh(128px, 105px);
      flex-shrink: 0;
      border-radius:4px 0 0 4px;
      overflow: hidden;
    }
    .info {
      flex-grow: 1;
      padding: 9px 7px;
      .title {
        @include ellipsis(1, 20px);
        margin-bottom: 7px;
      }
    }
  }
  .image-box {
    width: 100%;
    position: relative;
    > div {
      height: 100%;
      font-size: 0;
    }
    .vip-level {
      @include sc(11px, #fff);
      position: absolute;
      left: 0;
      top: 0;
      padding: 4px 10px;
      &.active {
        @include lg-radius(#FBE1B5, #E3A629, 4px 0px 4px 0px);
      }
    }
  }
  .info {
    .title {
      @include sc($font-size-md, $color-text-heavy);
    }
    .label {
      @include sc($font-size-base, $color-text-light)
    }
    .worth {
      @include sc($font-size-md, #F24724);
      @include lw(14px, 500);
    }
  }
}
</style>
